import { Dropdown, DropdownItem } from "flowbite-react";
import { Label } from "../../forms/Label/Label";
import { useTranslation } from "react-i18next";

type TYearDropdownProps = {
  year: string;
  onChange: (year: string) => void;
  yearRange?: { start: number; end: number };
};

const YearDropdown = ({ year, onChange, yearRange }: TYearDropdownProps) => {
  const currentYear = new Date().getFullYear();
  const start = yearRange?.start ?? currentYear - 5;
  const end = yearRange?.end ?? currentYear + 5;
  const years = Array.from({ length: end - start + 1 }, (_, i) =>
    String(start + i),
  );
  const { t } = useTranslation("common");
  return (
    <div className="dropdown-main-section">
      <Label weight={"medium"}>{t("FILTER.YEAR")}</Label>
      <Dropdown
        label={year}
        dismissOnClick={true}
        size="default"
        className="min-w-[130px] w-full flex justify-between text-left rounded-lg border bg-background px-2 py-2 text-sm text-foreground"
      >
        {years?.map((y) => (
          <DropdownItem
            key={y}
            className="hover:bg-slate-200 text-sm"
            onClick={() => onChange(y)}
          >
            {y}
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
};

export default YearDropdown;
